import { createAction } from '@reduxjs/toolkit';

import { ObjectiveCharacteristicsFormOutput } from '../../../modules/analysis/schObjectiveCharacteristics.ts';

export const submitObjectiveCharacteristicsForm = createAction<
  ObjectiveCharacteristicsFormOutput & { id: string }
>('submitObjectiveCharacteristicsForm');
